import { Box } from '@mui/material';
import React from 'react';
import { WhatsaapTemplatesList } from './WhatsaapTemplatesList';
import { Loading } from 'components/Loading';
import { WhatsaapTemplate } from 'services/whatsaapTemplates/types';

type Props = {
  isLoading: boolean;
  templatesList: WhatsaapTemplate[];
  templateIdSelected: string;
  onSelectTemplate: (template: WhatsaapTemplate) => void;
  isEdit: boolean;
  error: string | undefined;
};

export const TemplateListGroup: React.FC<Props> = ({
  isLoading,
  templatesList,
  templateIdSelected,
  onSelectTemplate,
  isEdit,
  error
}) => {
  if (isLoading) {
    return (
      <Box
        height={300}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Loading />;
      </Box>
    );
  }

  return (
    <WhatsaapTemplatesList
      templates={templatesList}
      templateIdSelected={templateIdSelected}
      onSelect={onSelectTemplate}
      disabled={isLoading || !!isEdit}
      error={error}
    />
  );
};
